import { ref } from 'vue';
const siteKey = ref(null);

export const useRecaptcha = () => {
	const executeRecaptcha = () => {
		window.grecaptcha.ready(async () => {
			window.grecaptcha.execute();
		});
	};
	const resetRecaptcha = () => {
		window.grecaptcha.reset();
	};

	const loadRecaptchaScript = (key, successCallback) => {
		return new Promise((resolve) => {
			window.onRecaptchaScriptLoad = () => {
				window.grecaptcha.render('rwtalgyik_invisible', {
					sitekey: siteKey.value,
					size: 'invisible',
					callback: successCallback,
					'expired-callback': resetRecaptcha
				});
				resolve();
			};
			siteKey.value = key;
			const script = document.createElement('script');
			script.src = `https://www.google.com/recaptcha/api.js?render=explicit&onload=onRecaptchaScriptLoad`;
			document.head.appendChild(script);
		});
	};
	return { loadRecaptchaScript, executeRecaptcha };
};
